// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3rDUR","colMin":"styles_colMin__3fu81","colCheckbox":"styles_colCheckbox__qpUuz"};